import { useCollisionDetection } from '../../hooks/useCollisionDetection';
import IconArrow from '../../svg/icon-arrow';
import {
  AltSymbol,
  Indicator,
  IndicatorContent,
  Wrapper,
} from './JourneySection.style';
import { useForceBreakpoint } from '@exploration/ui-utils';
import { ReactNode, useEffect, useRef } from 'react';

export interface JourneySectionProps {
  indicator: ReactNode;
  isStart?: boolean;
  isEnd?: boolean;
  isInverse?: boolean;
  isStacked?: boolean;
  staticIndicatorRef?: React.RefObject<HTMLElement>;
  containerRef?: React.RefObject<HTMLElement | null>;
  children: React.ReactNode;
}

const JourneySection = ({
  indicator,
  isStart,
  isEnd,
  isInverse,
  isStacked,
  // eslint-disable-next-line react-hooks/rules-of-hooks
  staticIndicatorRef = useRef(null),
  // eslint-disable-next-line react-hooks/rules-of-hooks
  containerRef = useRef(null),
  children,
}: JourneySectionProps) => {
  const baseDefaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };
  Wrapper.defaultProps = baseDefaultProps;
  Indicator.defaultProps = baseDefaultProps;

  const indicatorRef = useRef(null);
  const { isCollision, isPast } = useCollisionDetection(
    containerRef,
    staticIndicatorRef,
    indicatorRef,
  );

  useEffect(() => {
    if (staticIndicatorRef && staticIndicatorRef.current) {
      if (isCollision) {
        staticIndicatorRef.current.style.transform = 'rotate(-90deg)';
      } else {
        staticIndicatorRef.current.style.transform = 'rotate(0deg)';
      }
    }
  }, [isCollision, staticIndicatorRef]);

  useEffect(() => {
    if (isEnd && staticIndicatorRef && staticIndicatorRef.current) {
      if (isPast) {
        staticIndicatorRef.current.style.opacity = '0';
      } else {
        staticIndicatorRef.current.style.opacity = '1';
      }
    }
  }, [isPast, isEnd, staticIndicatorRef]);

  return (
    <Wrapper isStart={isStart} isStacked={isStacked}>
      <Indicator
        className="indicator"
        data-testid="indicator"
        isStart={isStart}
        isEnd={isEnd}
        isInverse={isInverse || (isEnd && isPast)}
        isActive={isCollision}
        isPast={isPast}
        ref={indicatorRef}
      >
        <IndicatorContent isEnd={isEnd} isPast={isPast}>
          {indicator}
        </IndicatorContent>
        <AltSymbol isEnd={isEnd} isPast={isPast}>
          <IconArrow />
        </AltSymbol>
      </Indicator>
      {children}
    </Wrapper>
  );
};

export default JourneySection;
